// Hợp đồng API của công cụ «Tải thumbnail đối thủ» (03/10/2026) — liệt kê video của một kênh YouTube.
import { z } from 'zod';
/** Mã playlist «Uploads» của một kênh: `UU` + phần sau của mã kênh `UC…`. */
const UPLOADS_PLAYLIST_ID = /^UU[0-9A-Za-z_-]{22}$/;
/** Mỗi lượt gọi trả tối đa bấy nhiêu video (một trang của YouTube Data API). */
export const THUMBNAIL_TOOL_PAGE_SIZE = 50;
export const thumbnailToolRequestSchema = z
    .object({
    /** Lượt đầu: link kênh (đủ dạng), link một video của kênh, `@tên` hay mã `UC…`. */
    url: z.string().trim().min(1).max(500).optional(),
    /** Các lượt sau: mã playlist «Uploads» máy chủ đã trả ở lượt đầu… */
    playlistId: z.string().regex(UPLOADS_PLAYLIST_ID).optional(),
    /** …cùng dấu trang kế của nó. */
    pageToken: z.string().min(1).max(200).optional(),
})
    .refine((value) => (value.url === undefined) !== (value.playlistId === undefined), {
    message: 'Gửi link kênh hoặc mã playlist, không phải cả hai',
});
//# sourceMappingURL=thumbnail-tool.js.map